
/**
 * Created by nijin on 31/1/17.
 */
import { Component, OnInit } from '@angular/core';
import {SchemaService} from "../schema.service";
import {GlobalService} from "../../global/global.service";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'nuc-predefined-schema',
    templateUrl: './predefined-schema.component.html',
    styleUrls: ['./predefined-schema.component.scss']
})
export class PredefinedSchemaComponent implements OnInit {
  predefinedSchemaList: Array<any> = [];
  schemaCategoryList: Array<any> = [] ;
  isLoading:boolean;
  isCatLoading:boolean;
  constructor(
    private schemaService: SchemaService,
    private globalService: GlobalService
    ) { }


    ngOnInit() {
      this.getAllPredefinedSchemas();
      this.getSchemaCategory();
    }


  getAllPredefinedSchemas(){
    this.isLoading = true;
    this.schemaService.getPredefinedSchemaList()
      .subscribe((response)=>{ this.predefinedSchemaList = response.items; this.isLoading = false;},()=>{this.isLoading = false})
  }
  getSchemaCategory(){
    this.isCatLoading = true;
    this.globalService.getConfigDataByType(this.globalService.SCHEMA_CATEGORY)
      .subscribe( (response) => {
          this.schemaCategoryList = response.items;
          this.isCatLoading = false
        },
        res => this.isCatLoading = false);
  }


}



// WEBPACK FOOTER //
// ./src/app/schema/schema-list/predefined-schema.component.ts